module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (140).30ebf978.jpg";